import { render, staticRenderFns } from "./ColorGauge.vue?vue&type=template&id=1b1c7ca0&"
import script from "./ColorGauge.vue?vue&type=script&lang=js&"
export * from "./ColorGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1c7ca0')) {
      api.createRecord('1b1c7ca0', component.options)
    } else {
      api.reload('1b1c7ca0', component.options)
    }
    module.hot.accept("./ColorGauge.vue?vue&type=template&id=1b1c7ca0&", function () {
      api.rerender('1b1c7ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Gauges/ColorGauge.vue"
export default component.exports